import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ItemGrid from "~/ui/ItemGrid";
import css from './css.css';
import { connect } from '~/redux/connect';
import {pushClose} from "~/actions/navigation_actions";
import connectItemBar from "~/ui/ItemBar/connectItemBar";
import ItemActions from "~/ui/ItemBar/ItemActions";
import {getItemLoadingState} from "~/conclude/loading";
import LoadingContainer from "~/components/LoadingContainer/LoadingContainer";
import ItemViewMessageList from "~/ui/MessageList/ItemViewMessageList";
import Icon from "~/ui/ReactML/Icon";


import { Button, Dialog, Divider, HStack, LinkToSpan, Spinner, Text, renderHTML } from "~/native-ui";

const emptyObject = {};

class ItemViewDialog extends Component {
	static propTypes = {
        modelId: PropTypes.string,
		// routeDelay: PropTypes.number.isRequired,
		openDelay: PropTypes.number.isRequired,
	};

	static defaultProps = {
		// routeDelay: 500,
		openDelay: 100
	};

	state = {
		active: false,
	};

	syncStateTimeout = null;

	close = () => {
        return this.props.pushClose();
	};

	renderActions = () => {
		let props = this.props;
		let { trans, ready, loading } = props;

		return ready ? <LoadingContainer ready={true} loading={loading}>
				<HStack justifyContent="flex-end" alignItems="center">
					<Button label={trans('close')} icon="highlight-off" onClick={this.close} />
					<Divider key={"divider"} orientation="vertical" bg="coolGray.300" h="5" mx="2" />
					<ItemActions {...props} />
				</HStack>
			</LoadingContainer> : null;
	};

	renderItemGrid = () => {
		let props = this.props;
        let { modelId, ready, loading, error } = props;

		return (
            <LoadingContainer error={error} ready={ready} loading={loading}>
                <ItemViewMessageList className={css.messageList} modelId={modelId} />
                <ItemGrid modelId={modelId} className={css.itemGrid} maxLevel={0} view={this.props.view} />
			</LoadingContainer>
		);
	};

	syncState = (nextProps) => {
		const doSync = () => {
            let data = {
                modelId: nextProps.modelId,
                active: !!nextProps.modelId
            };

            // console.log('doSync ItemViewDialog', data, nextProps);

            this.setState(data);
		};

		let ready = nextProps.ready,
			modelId = nextProps.modelId;

		clearTimeout(this.syncStateTimeout);

		if(ready || !modelId) {
			return doSync();
		}

        this.syncStateTimeout = setTimeout(() => {
            doSync();
		}, nextProps.openDelay);
	};

	componentDidMount = () => {
        this.syncState(this.props);
	};

    componentWillReceiveProps = (nextProps) => {
    	this.syncState(nextProps);
	};

    getTitle = () => {
        let titleHtml = this.props.title ? renderHTML(this.props.title, {
            a: LinkToSpan,
			icon: Icon
        }) : '';

        let loading = this.props.loading;
        let ready = this.props.ready;

		return (
			<HStack space={2}>
				{loading && ready && <Spinner h3 className={css.loading} />}
				<Text fontSize="inherit" lineHeight="inherit">{titleHtml}</Text>
			</HStack>
		);
	};

	render() {

		return (
            <Dialog
				title={this.getTitle()}
				className={css.dialog}
                actions={this.renderActions()}
                active={this.state.active}
                onOverlayClick={this.close}
                onEscKeyDown={this.close}
            >
				{this.renderItemGrid()}
            </Dialog>
		);
	}
}

const RXItemViewDialog = connectItemBar(connect((state, {modelId}) => {
	let loadingState = emptyObject;

	if(modelId) {
    	loadingState = getItemLoadingState(state, modelId);

    	// console.log('RXItemViewDialog', loadingState)
    }

    return {
		...loadingState,
	}
}, (dispatch) => {
    return {
        pushClose: (...args) => dispatch(pushClose(...args)),
    }
})(ItemViewDialog));



export default RXItemViewDialog;